import _defineProperty from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
/** @clearscore/helpers.create-axios-clients v0.4.15: 2022-12-12 17:54 (assemble v5.5.1) **/
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import axios from 'axios';
import interpolateWithMarket from '@clearscore/helpers.interpolate-with-market';
var UNKNOWN_CLIENT_ERROR = function UNKNOWN_CLIENT_ERROR(client) {
  return "ERROR [add-client-instance]: Unknown client '".concat(client, "'.\n     Please check allowed clients in @clearscore/helpers.add-client-instance");
};
var createClients = function createClients(clientDirectory) {
  var clients = Object.keys(clientDirectory).reduce(function (prev, clientName) {
    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, clientName, axios.create(clientDirectory[clientName])));
  }, {});
  return function (clientKey, state, requestMeta) {
    var client = clientDirectory[clientKey];
    var clientConfiguration = clients[clientKey];
    if (!client || !clientConfiguration) throw Error(UNKNOWN_CLIENT_ERROR(clientKey));
    var isFunction = function isFunction(config) {
      return typeof config === 'function';
    };
    var baseURL = isFunction(client.baseURL) ? client.baseURL(state) : client.baseURL;
    var interpolatedURL = baseURL ? interpolateWithMarket({
      state: state,
      url: baseURL,
      market: requestMeta ? requestMeta.market : null
    }) : null;
    clientConfiguration.defaults.baseURL = interpolatedURL;
    return clientConfiguration;
  };
};
export { createClients as default };